import React, { useRef, useState } from 'react';
import * as Yup from 'yup';
import { AccreditationDetails } from '../../../sc-models/scope-certificate-details-dto';
import FormBuilder from '../../../../../shared/components/form-builder/form-builder';
import { useParams } from 'react-router-dom';

interface AccreditationDetailsFormProps {
  formRef: any;
  accreditationData: AccreditationDetails;
  setAccreditationData: React.Dispatch<React.SetStateAction<AccreditationDetails>>;
}

const AccreditationDetailsForm: React.FC<AccreditationDetailsFormProps> = ({
  formRef,
  accreditationData,
  setAccreditationData,
}) => {
  const { formtype } = useParams();
  const hasSubmitSC: boolean = formtype === 'submited-sc';
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    if (drawerOpen) resetForm();
    setDrawerOpen((prev) => !prev);
  };

  const resetForm = () => {
    setAccreditationData(accreditationData);
  };

  const formConfig = {
    pageName:"scope-certificate-details",
    initialValues: accreditationData,
    validationSchema: Yup.object().shape({
      scScopeStipulations: Yup.string().nullable(),
      accreditationBody: Yup.string().required('Accreditation Body is required'),
      accreditationNo: Yup.string().nullable(),
      inspectionBody: Yup.string().nullable(),
    }),
    readOnly: hasSubmitSC,
    sections: [
      {
        title: 'Accreditation Details',
        fields: [
          {
            label: 'SC Scope Stipulations',
            name: 'scScopeStipulations',
            type: 'text',
            required:false,
            gridSize: { xs: 12, md: 6, lg: 3 },
            props: { placeholder: 'Enter Scope Stipulations (optional)' },
          },
          {
            label: 'CB Accreditation Body',
            name: 'accreditationBody',
            type: 'select',
            gridSize: { xs: 12, md: 6, lg: 3 },
            required: true,
            props: {
              options: [
                { value: 'SLAB', label: 'SLAB' },
                { value: 'IOAS', label: 'IOAS' },
                { value: 'ANAB', label: 'ANAB' },
                { value: 'TAF', label: 'TAF' },
                { value: 'COFRAC', label: 'COFRAC' },
                { value: 'IAJapan', label: 'IA Japan' },
                { value: 'DAkkS', label: 'DAkkS' },
              ],
              placeholder: 'Select Accreditation Body',
            },
          },
          {
            label: 'Accreditation No.',
            name: 'accreditationNo',
            type: 'text',
            required:false,
            gridSize: { xs: 12, md: 6, lg: 3 },
            props: { placeholder: 'Enter Accreditation No. (optional)' },
          },
          {
            label: 'Inspection Body',
            name: 'inspectionBody',
            type: 'text',
            required:false,
            gridSize: { xs: 12, md: 6, lg: 3 },
            props: { placeholder: 'Enter Inspection Body (optional)' },
          },
        ],
      },
    ],
    handleSubmit: (values: any) => {
      setAccreditationData(values);
      toggleDrawer();
    },
  };

  return <FormBuilder formConfig={formConfig} onSubmit={formConfig.handleSubmit} formRef={formRef} />;
};

export default AccreditationDetailsForm;
